import { inject, Injectable } from '@angular/core';
import { DynamicSettings } from '@common-modules/common-persistency/models/dynamic-settings';
import { DynamicLayoutSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-settings';
import { DynamicSettingsService } from '@common-modules/shared/config/dynamic-settings.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DynamicSettingsDelete } from './models/dynamic-settings-delete';
import { DynamicSettingsSave } from './models/dynamic-settings-save';
import { PersistSettingsService } from './persist-settings.service';

@Injectable()
export class PersistSettingsBackendService extends PersistSettingsService {
  private readonly _dynamicSettingsService = inject(DynamicSettingsService);

  load(settings: DynamicSettings): Observable<DynamicLayoutSettings> {
    return this._dynamicSettingsService.loadDynamicSettings(settings).pipe(
      tap((result: DynamicLayoutSettings) => {
        if (result && !result.items) {
          console.error(
            `The settings recovered for `,
            settings,
            ' are not valid for this version of Dynamic Layout. Please delete them before.'
          );
        }
      })
    );
  }
  save(settings: DynamicSettingsSave): Observable<void> {
    return this._dynamicSettingsService.saveDynamicSettings(settings);
  }
  delete(settings: DynamicSettingsDelete): Observable<any> {
    return this._dynamicSettingsService.deleteDynamicSettings(settings);
  }
}
